import { assetModelBrandsSlice } from "./assetModelBrandsSlice";
import * as actions from "./assetModelBrandsActions";
import * as selectors from "./assetModelBrandsSelectors";

export { actions };
export { selectors };
export default assetModelBrandsSlice.reducer;
